import _ from "@lodash";
import { AppBar, Card, CardContent, DialogContent, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import { showMessage } from "app/store/actions";
import withReducer from "app/store/withReducer";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Actions from "./Store/Actions/AlertasActions";
import AlertasReducer from "./Store/Reducers/AlertasReducer";

const styles = () => ({
    addButton: {
    },
});

function Alertas(props) {

    const dispatch = useDispatch();
    const reducer = useSelector(({ AlertasReducer }) => AlertasReducer);
    const [painelOpen, setPainelOpen] = useState(false);

    useEffect(() => {
        dispatch(Actions.list("SELECIONAR", props.xappRouteParams, { idpessoaformulario: props.idpessoaformulario, idfontepagadora: props.idfontepagadora }));
    }, [props.idpessoaformulario, props.idfontepagadora]);

    useEffect(() => {
        if (!_.isNull(reducer.error)) {
            dispatch(showMessage({
                message: reducer.error,
                variant: "error"
            }));
            reducer.error = null;
        }
    }, [reducer.error]);

    useEffect(() => () => dispatch(Actions.clearReducer()), []);

    return (
        <React.Fragment>
            {(reducer.data?.length ?? 0) > 0 &&
                <XAPPButton
                    id="btn-alertas"
                    type="Icon"
                    variant="contained"
                    color={!_.isUndefined(props.color) ? props.color : "primary"}
                    icon={"warning"}
                    iconProps={""}
                    badge={reducer.data?.length ?? 0}
                    className={!_.isUndefined(props.className) ? props.className : "text-white"}
                    onClick={() => setPainelOpen(true)}
                />
            }
            <XAPPDialog
                id="AgendamentoAlertas"
                open={painelOpen}
                onClose={() => setPainelOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {"Alertas importantes"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <XAPPButton
                            key="close"
                            type="Icon"
                            className="p-6"
                            onClick={() => setPainelOpen(false)}
                            icon={"close"}
                            iconProps={"text-20 text-white"}
                        />
                    </Toolbar>
                </AppBar>
                <DialogContent classes={{ root: "p-12" }}>
                    {reducer.data?.map((item, x) => (
                        <Card
                            key={x}
                            className={"w-full mb-16 rounded-4 relative cursor-pointer"}
                            elevation={1}
                        >
                            <CardContent>
                                <Typography variant="subtitle1">
                                    {item.alerta}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </DialogContent>
            </XAPPDialog>
        </React.Fragment>
    );
}

Alertas.propTypes = {
    idpessoaformulario: PropTypes.string.isRequired,
    idfontepagadora: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    xappRouteParams: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(withReducer("AlertasReducer", AlertasReducer)(withRouter(Alertas)));
